import InfoPopover from "../infoPopover/infoPopover"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * Single-line text input with reset functionality and placeholder support.
 * @param {Object} props
 * @param {Object} props.element - Configuration element
 * @param {Object} props.parameters - Current parameters state
 * @param {Function} props.setParameters - Function to update parameters
 * @returns {JSX.Element}
 */
function TextEditor({ element, parameters, setParameters }) {
  const { t } = useLanguage()

  if (!element) {
    return <div className="row textEditor" />
  }

  const value = parameters && parameters[element.id] ? parameters[element.id] : ""

  /**
   * Updates the text value in parameters.
   * @param {Event} event
   */
  const setText = event => {
    if (setParameters && parameters) {
      setParameters({ ...parameters, [element.id]: event.target.value })
    }
  }

  const resetText = () => {
    if (setParameters && parameters) {
      setParameters({ ...parameters, [element.id]: element.default })
    }
  }

  const exampleText = element.placeholder && typeof t === "function" ? t(element.placeholder) : ""

  return (
    <div className="row textEditor">
      <div className="col-5 d-flex justify-content-end align-items-center">
        {element?.label ? (typeof t === "function" ? t(element.label) : element.label) : element?.label}
        <InfoPopover element={element} />
      </div>
      <div className="col">
        <input type="text" id={`input-${element.id || "default"}`} className="form-control" value={value} onChange={setText} placeholder={exampleText} />
        <div className="resetBloc" data-testid="reset-button" onClick={resetText}></div>
      </div>
    </div>
  )
}

export default TextEditor
